/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Mfa_MissingInputs */

const fr_account_audit_mfa_missing = /** @type {(inputs: Account_Audit_Mfa_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double authentification non activée`)
};

/**

* @param {Account_Audit_Mfa_MissingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_mfa_missing = /** @type {((inputs?: Account_Audit_Mfa_MissingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Mfa_MissingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_mfa_missing(inputs)
});